import { Action, Reducer } from 'redux'
import { AppThunkAction } from '.'

import { LeaveType as LeaveTypeModel } from '../model'
import { setJWT } from '../helper';

// -----------------
// STATE - This defines the type of data maintained in the Redux store.

export interface LeaveTypeState {
    isLoading: boolean
    leaveTypeList: LeaveTypeModel[]
}

// -----------------
// ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
// They do not themselves have any side-effects; they just describe something that is going to happen.


interface RequestLeaveTypeAction {
    type: 'REQUEST_LEAVETYPE'
}

interface ReceiveLeavTypeAction {
    type: 'RECEIVE_LEAVETYPE'
    leaveTypeList: LeaveTypeModel[]
}

// Declare a 'discriminated union' type. This guarantees that all references to 'type' properties contain one of the
// declared type strings (and not any other arbitrary string).
type KnownAction =
    RequestLeaveTypeAction
    | ReceiveLeavTypeAction
    ;

// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).

export const actionCreators = {
    requestLeaveType: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();


        if (appState && appState.leaveType) {
            let fetchDest = 'api/leaveType'

            let httpOptions: any = {};

            setJWT(httpOptions, appState);

            fetch(fetchDest, httpOptions)
                .then(response => response.json() as Promise<LeaveTypeModel[]>)
                .then(data => {
                    dispatch({ type: 'RECEIVE_LEAVETYPE', leaveTypeList: data });
                })
                .catch(() => {

                    dispatch({ type: 'RECEIVE_LEAVETYPE', leaveTypeList: [] });
                })

            dispatch({ type: 'REQUEST_LEAVETYPE' });
        }
    },
};

// ----------------
// REDUCER - For a given state and action, returns the new state. To support time travel, this must not mutate the old state.

const unloadedState: LeaveTypeState = { leaveTypeList: [], isLoading: false };

export const reducer: Reducer<LeaveTypeState> = (state: LeaveTypeState | undefined, incomingAction: Action): LeaveTypeState => {
    if (state === undefined) {
        return unloadedState;
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'REQUEST_LEAVETYPE':
            return {
                leaveTypeList: state.leaveTypeList,
                isLoading: true,
            };

        case 'RECEIVE_LEAVETYPE':
            // Only accept the incoming data if it matches the most recent request. This ensures we correctly
            // handle out-of-order responses.
            return {
                leaveTypeList: action.leaveTypeList,
                isLoading: false,
            };
    }

    return state;
};
